<template>
  <div>
   <div class="nameDiv">
     <div class="nameLeftDiv">某某某</div>
     <div class="namerightDiv"></div>
   </div>
  </div>
</template>
<script>
  export default {
    name:'my',
    data(){
      return {
        msg: ""
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/my.vue